$.fn.select2.defaults.set( "theme", "bootstrap4" );

$(document).ready(function() {
    $('.select2').select2();
    $('.select2-taggable').select2({
        tags: true
    });

    $('.datepicker-init').each(function () {
        let defaultValue = $(this).data('prefill');
        let disabledDays = $(this).data('disabled-days');

        let options = {
            format: 'DD/MM/YYYY'
        };
        if(disabledDays != null){
            options['daysOfWeekDisabled'] = disabledDays;
        }
        if(defaultValue){
            options['defaultDate'] = moment(defaultValue, 'DD/MM/YYYY');
        }

        $(this).datetimepicker(options);

        if(disabledDays != null && !defaultValue){
            $(this).val('');
        }
    });

    $('.daterangepicker-init').daterangepicker({
        locale: {
            format: 'DD/MM/YYYY'
        }
    });

    $('form.confirm-submit').on('submit', (e) => {
        if(!confirm('Are You Sure You Want To Delete This?')){
            e.preventDefault();
        }
    });
});
